<script setup lang="ts">
import type {UsedTokens} from '@/client/mentor/MessagesClient'
import DebugBadge from '@/components/assistant/chat/message/DebugBadge.vue'
import {computed} from 'vue'

const props = defineProps<{
  usedTokens?: UsedTokens | null
}>()

const totalTokens = computed(() => {
  const tokens = props.usedTokens
  if (tokens == null) return null
  return tokens.input + tokens.output + (tokens.cacheRead ?? 0) + (tokens.cacheWrite ?? 0)
})

function tokenShare(part: number, total: number): string {
  if (total <= 0) return '0%'
  return `${Math.round((part / total) * 100)}%`
}
</script>

<template>
  <DebugBadge v-if="usedTokens != null && totalTokens != null" badge-class="bg-teal-50 text-teal-700 border-teal-200">
    Tokens: {{ totalTokens }}

    <template #popper>
      <p class="mb-1 text-[11px] font-bold uppercase opacity-60">Token usage</p>
      <div class="flex flex-col gap-0.5 text-[11px] leading-relaxed">
        <span>Input: {{ usedTokens.input }} ({{ tokenShare(usedTokens.input, totalTokens) }})</span>
        <span>Output: {{ usedTokens.output }} ({{ tokenShare(usedTokens.output, totalTokens) }})</span>
        <span v-if="usedTokens.cacheRead">
          Cache read: {{ usedTokens.cacheRead }} ({{ tokenShare(usedTokens.cacheRead, totalTokens) }})
        </span>
        <span v-if="usedTokens.cacheWrite">
          Cache write: {{ usedTokens.cacheWrite }} ({{ tokenShare(usedTokens.cacheWrite, totalTokens) }})
        </span>
      </div>
    </template>
  </DebugBadge>
</template>
